/**
 * 全局配置文件
 */

/** ArcGIS 地图配置 */
export const CONST_CONFIG = {
  /** ArcGIS API Key (可选，用于高级功能) */
  API_KEY: '', // 基础地图不需要
  /** 地图中心点 (经度, 纬度) - 新加坡 */
  CENTER: [103.8198, 1.3521] as [number, number],
  /** 地图层级 */
  ZOOM: 12,
  /** 底图样式 */
  BASEMAP: 'ignite' as const,
  /** 深色底图样式 */
  BASEMAP_DARK: 'ignite' as const,
  /** Geek 底图样式 */
  BASEMAP_GEEK: 'ignite' as const,
  /** Hero Light 底图样式 */
  BASEMAP_HERO_LIGHT: 'ignite' as const,
  /** Hero Dark 底图样式 */
  BASEMAP_HERO_DARK: 'ignite' as const,
  /** Cyber 底图样式 (深色夜景) */
  BASEMAP_CYBER: 'ignite' as const,
  /** Tech 底图样式 (深色夜景) */
  BASEMAP_TECH: 'ignite' as const,
  /** Blue 底图样式 (深灰色) */
  BASEMAP_BLUE: 'ignite' as const,
  /** Ignite 底图代理地址 (开发和生产环境统一使用 /ignite-proxy) */
  IGNITE_PROXY_URL: '/ignite-proxy',
} as const
